angular.module( 'acme.view.application.donations.amount.list', [
  'ui.router',
  'ui.bootstrap',
  'acme.view.application.donations.amount.list.controllers'
])

.config(function config( $stateProvider ) {

  // Create both abstract view and template view.
  // Abstract Views are enabled by default
  var donationsAmountList = {
        name: 'application.donations.amount.list',
        url: '/list',
        views: {
          "subview-main": {
            controller: 'DonationsAmountListController',
            templateUrl: 'views/application/views/donations/amount/list/list.tpl.html'
          }
        },
        data: {
          pageTitle: 'Amount List',
          enablePreferences: true
        }
      };

    $stateProvider
      .state(donationsAmountList);
});
